export enum OnboardingServices {
  Partner = 'partner',
  Request = 'request',
  Contact = 'contact',
  Search = 'search',
  PartnerFlag = 'change-flag-request',
  Validator = 'validator',
}

export enum OnboardingValidatorServiceMethods {
  Validate = 'validate',
}

export enum OnboardingPartnerFlagServiceMethods {
  Save = 'save',
}

export enum OnboardingContactServiceMethods {
  Create = 'create',
  Update = 'update',
  Replacement = 'replacement',
  UpdateFlags = 'updateFlags',
  updateIsPreferredContactFlag = 'update-is-preferred-contact',
  GetContactsWithFlags = 'get-contacts-with-flags',
  Activation = 'activation',
  Relink = 'relink',
}

export enum OnboardingPartnerServiceMethods {
  Create = 'create',
  Update = 'update',
  UpdateAdditional = 'saveAdditionalInfo',
  SearchPortalContact = 'searchPortalContact',
}

export enum OnboardingSearchServiceMethods {
  Contacts = 'contacts',
  Partners = 'partners',
}

export enum OnboardingRequestServiceMethods {
  StartRequest = 'startRequest',
}

export enum OnboardingRequestTypes {
  Onboarding = 'Onboarding',
  PartnerRegistr = 'PartnerRegistr',
  Contract = 'Contract',
  Exception = 'Exception',
  Retail = 'Retail',
  RetailException = 'RetailException',
  RetailOnboarding = 'RetailOnboarding',
  BPRegistration = 'BPRegistration',
  SimplePartnerRegistration = 'SimplePartnerRegistration',
  BPReconfirmation = 'BPReconfirmation',
}

export enum OnboardingValidatorSchema {
  CG_CONTACT = 0,
}

export enum OnboardingResponseStatus {
  Success = 'success',
  Fail = 'fail',
  Error = 'error',
}

export type OnboardingFail = {
  message: string
}

export type OnboardingValidateFail = OnboardingFail & {
  field: string
  type: string
}

export type OnboardingResponse<F extends OnboardingFail = OnboardingFail, T = undefined> =
  | {
      status: OnboardingResponseStatus.Error
      message: string
    }
  | {
      status: OnboardingResponseStatus.Success
      data: T
    }
  | {
      status: OnboardingResponseStatus.Fail
      data: OnboardingFailData<F>
    }

export type OnboardingFailData<F extends OnboardingFail = OnboardingFail> =
  | F[]
  | {
      code?: number
      error?: F[]
      message?: string
      messages?: string[]
    }
